export enum FilterTypesInstantSearch {
  RANGE = "range",
  REFINEMENT_LIST = "refinementList",
}
